// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

	if(document.querySelectorAll('.form-module__field').length > 0){
		document.querySelectorAll('.form-module__field').forEach(field => {
			if(field.querySelector('input')){
				field.querySelector('input').addEventListener('focus', ()=> {
					field.classList.add('focus')
				})
			}
			if(field.querySelector('select')){
				field.querySelector('select').addEventListener('focus', ()=> {
					field.classList.add('focus')
				})
			}
			if(field.querySelector('textarea')){
				field.querySelector('textarea').addEventListener('focus', ()=> {
					field.classList.add('focus')
				})
			}
		});
	}

    let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
	itemsMenu.forEach((itemMenu)=>{
		if(itemMenu.querySelector('.submenu')){
			itemMenu.addEventListener('mouseenter',()=>{
				itemMenu.classList.add('hover');
				itemMenu.querySelector('.submenu').classList.add('show');
			});
			itemMenu.addEventListener('mouseleave',()=>{
				itemMenu.classList.remove('hover');
				itemMenu.querySelector('.submenu').classList.remove('show');
			})
		}
	})

	let cardItems = document.querySelectorAll('.menus-cards__item');
    cardItems.forEach(function(cardItem) {
		cardItem.addEventListener('mouseenter', function() {
			
			var cardText = cardItem.querySelector('.menus-cards__item--text');
			if (cardText) {
				cardText.classList.add('active');
			}
		});

		cardItem.addEventListener('mouseleave', function() {
			var cardText = cardItem.querySelector('.menus-cards__item--text');
			if (cardText) {
				cardText.classList.remove('active');
			}
		});
	});

	if(document.querySelector('.menus-quad')){
		let tabMenus = document.querySelectorAll('.menus-quad__item a');
		
		tabMenus.forEach((tab)=>{
			tab.addEventListener('click',()=>{
				let data = tab.dataset.menu;
				customLightboxMenus.beforeShow = function () {
					document.querySelector(`.menus-quad__intern[data-menu="${data}"]`).click();
				};
			})
		})
	}

	//for Menus
	document.querySelectorAll('.menu-restaurant__tabs li').forEach((btn, i) => {
		btn.addEventListener('click', _ => {
			document.querySelectorAll('.menu-restaurant__tabs li').forEach(b => b.classList.remove('active'));
			btn.classList.add('active');

			document.querySelectorAll('.menus-quad__unitmenu').forEach(menu => {
				menu.classList.add('hidden');
				if ( btn.dataset.menu === menu.dataset.menu ) {
					menu.classList.remove('hidden');
				}
			});
		});

		if (i === 0) btn.click();
	});

	// Menu Functionality

	let menuContent = document.getElementById("navigationBox");
	let header = document.getElementById("header");
	let menuBtn = document.querySelector("[data-show_nav]");
	let closeMenuBtn = document.querySelector("[data-close_nav]");
	// let menuLabel = menuBtn.querySelector('span.label');
	//Open/CLose

	if(menuBtn){
		menuBtn.addEventListener('click', function (e) {
			menuBtn.classList.toggle("open");
			menuContent.classList.toggle("open");
			header.classList.toggle("menuOpen");
		});
	}

	if(closeMenuBtn){
		closeMenuBtn.addEventListener('click', function (e) {
			menuBtn.classList.remove("open");
			menuContent.classList.remove("open");
			header.classList.remove("menuOpen");
		});
	}


    window.onload = function() {
		scrollDownAction(80, 'scroll');
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	if(document.querySelector('.accordion')){
		document.querySelectorAll('.accordion').forEach((accordion) => {
			accordion.querySelectorAll('.js-accordion-title').forEach((itemHead) => {
				itemHead.addEventListener('click', (e) => {
					accordion.querySelectorAll('.js-accordion-item').forEach((item) => {
						if (itemHead.parentNode !== item) item.classList.remove('open');
					});
					itemHead.parentNode.classList.toggle('open');
				});
			});
		});
	}

	const LBXquadsCustom = new LBX(".btn-lightbox");

	const text_h1 = document.getElementById("circle-text")
	if (text_h1){
		const text_array = text_h1.textContent.split('')
		text_h1.textContent = ''
		var s = 34;
		for(var i = 0; i< text_array.length; i++){
			text_h1.innerHTML += '<span style="transform:rotate('+s+'deg)">'+ text_array[i] +'</span>';
			s += 6;
		}
	}


})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}